import React from 'react'
import classNames from 'classnames'
import { GxIcon, GxInput } from '@garpix/garpix-web-components-react'
import ErrorText from '../ErrorText'
import { attentionIcon, eyeIcon, eyeIcon2 } from '@/images'
import style from './styles/input.module.scss'

interface InputProps {
  autocomplete?: string
  children?: React.ReactElement | null
  className?: string
  error?: string
  label?: string
  name?: string
  placeholder?: string
  theme?: string
  required?: boolean
  type:
  | 'number'
  | 'text'
  | 'search'
  | 'email'
  | 'password'
  | 'tel'
  | 'url'
  | undefined
  value?: string
  disabled?: boolean
}

const Input = ({
  children = null,
  className = '',
  error = '',
  label = '',
  required = false,
  theme = 'gray',
  type,
  ...props
}: React.PropsWithChildren<InputProps>): React.ReactElement => {
  return (
    <GxInput
      label={label}
      required={required}
      data-error={error}
      type={type}
      className={classNames({
        [style.default]: true,
        [style[`theme_${theme}`]]: theme,
        [className]: Boolean(className)
      })}
      {...props}
    >
      {children}

      {type === 'password'
        ? (
          <>
            <GxIcon
              src={eyeIcon}
              slot='hide-password-icon'
              className={style.icon_password}
            />
            <GxIcon
              src={eyeIcon2}
              slot='show-password-icon'
              className={style.icon_password}
            />
          </>
          )
        : (
            undefined
          )}
      {error !== ''
        ? (
          <>
            <GxIcon
              src={attentionIcon}
              slot='suffix'
              className={style.icon_error}
            />
            <ErrorText text={error} />
          </>
          )
        : (
            undefined
          )}
    </GxInput>
  )
}

export default Input
